module.exports = __webpack_public_path__ + "static/media/microsoftXbrainstation.e902b4d0.png";